<template>
  <a-layout id="components-layout-demo-top-side">
    <a-layout-header class="header">
      <Navbar />
    </a-layout-header>
    <a-layout-content :style="{ padding: '0 50px', minHeight: '780px' }">
      <router-view />
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      <Footer />
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default{
  name:"NoSidebar",
  components:{
    Navbar,
    Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/views/NoSidebar.vue